import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const spin: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'recordDate' },
            { type: 'field', field: 'adjustmentFactor' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'payDate' },
            { type: 'field', field: 'stockTicker' },
        ],
    },
];

export default spin;
